module.exports = __webpack_public_path__ + "static/media/Milagros_Rodriguez_C_ES.0e2bec3c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/store/Milagros_Rodriguez_C_ES.pdf
// module id = 230
// module chunks = 0